import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useGetRecentSearches(query) {
  const common = v => ({ params: v ? { query: v } : null });
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/recent_searches',
    method: 'GET',
    ...common(query),
  }, { manual: true });
  const executeQuery = React.useCallback(newQuery => q(common(newQuery)), [q]);
  return [state, executeQuery];
}

export function usePutRemoveRecentSearches(id) {
  const common = v => ({ url: `/api/v1/recent_searches/${v}/remove` });
  const [state, q] = useAxios({ ...common(id), method: 'PUT' }, { manual: true });
  const executeQuery = React.useCallback(newId => q(common(newId)), [q]);
  return [state, executeQuery];
}
